define('Components/ProductListWidget/js/ProductListWidget',['hooks',
    'Components/ProductListWidget/js/models/MediaProductListWidgetInstanceModel',
    'Components/ProductListWidget/js/models/SimpleProductListWidgetInstanceModel',
    'Components/ProductListWidget/js/models/CheckoutCTAWidgetInstanceModel',
    'Components/ProductListWidget/js/views/ProductListWidgetInstanceView',
    'Components/ProductListWidget/js/views/CheckoutCTAWidgetInstanceView',
    'Components/ProductListWidget/js/views/WithMediaProductListWidgetInstanceView'
    ],
    function(hooks,
        MediaProductListWidgetInstanceModel,
        SimpleProductListWidgetInstanceModel,
        CheckoutCTAWidgetInstanceModel,
        ProductListWidgetInstanceView,
        CheckoutCTAWidgetInstanceView,
        WithMediaProductListWidgetInstanceView
        ){

    return function() {
        hooks.registerWidgetInstance('ProductListWidget', {
            'simple-4x1': ProductListWidgetInstanceView,
            'fidelity': ProductListWidgetInstanceView,
            'simple-4x2': ProductListWidgetInstanceView,
            'product-page-footer': ProductListWidgetInstanceView,
            'with-media': WithMediaProductListWidgetInstanceView,
           'checkout-CTA': CheckoutCTAWidgetInstanceView,
        }, {
            'simple-4x1': SimpleProductListWidgetInstanceModel,
            'fidelity': SimpleProductListWidgetInstanceModel,
            'simple-4x2': SimpleProductListWidgetInstanceModel,
            'product-page-footer': SimpleProductListWidgetInstanceModel,
            'with-media': MediaProductListWidgetInstanceModel,
            'checkout-CTA': CheckoutCTAWidgetInstanceModel,
        });
    }
});
